import React from 'react';
import LinkButton from './LinkButton'

const StartTest = () => (
  <div style={{textAlign:"center"}}>
    <LinkButton to="/sections/warmup" >Start Test</LinkButton>
  </div>
)

export default StartTest;



/** WEBPACK FOOTER **
 ** ./src/components/StartTest.js
 **/